import { render, staticRenderFns } from "./RecyclePercentageAndTypeChart.vue?vue&type=template&id=388c53ac&scoped=true"
import script from "./RecyclePercentageAndTypeChart.vue?vue&type=script&lang=js"
export * from "./RecyclePercentageAndTypeChart.vue?vue&type=script&lang=js"
import style0 from "./RecyclePercentageAndTypeChart.vue?vue&type=style&index=0&id=388c53ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c53ac",
  null
  
)

export default component.exports